/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'state_escalator': {
    width: 16,
    height: 16,
    viewBox: '0 0 61.17 61.17',
    data: '<g data-name="图层 2"><g data-name="图层 1" _fill="#df4545"><path pid="0" d="M30.59 0a30.59 30.59 0 1030.58 30.59A30.62 30.62 0 0030.59 0zm0 60.17a29.59 29.59 0 1129.58-29.58 29.62 29.62 0 01-29.58 29.58z"/><path pid="1" d="M31.09 18.39h-1v11.27H20.06l10.53 13.12 10.53-13.12H31.09V18.39z"/></g></g>'
  }
})
